import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import PageShell from "@/components/PageShell";
import PageHeader from "@/components/PageHeader";
import SiteFooter from "@/components/SiteFooter";
import CTASection from "@/components/sections/CTASection";

const FAQS = [
  { q: "Do you provide same-day printing?", a: "Yes — for select small-format items submitted before 11 AM with print-ready artwork, we can produce and deliver within the same business day across Dubai." },
  { q: "Do you offer UAE-wide delivery?", a: "Absolutely. We deliver across all seven Emirates — Dubai, Abu Dhabi, Sharjah, Ajman, Umm Al Quwain, Ras Al Khaimah and Fujairah — with express options available." },
  { q: "Can products be customized?", a: "Every product is fully customisable — size, branding, finish, packaging. Share your brief and our design team will revert with a tailored proposal within 24 hours." },
  { q: "Do you provide design consultation?", a: "Yes — free 30-minute design consultations are included with every quote. Our in-house designers help you optimise artwork for print, finish and budget." },
  { q: "Is there a minimum order quantity?", a: "There is no fixed MOQ for most items. Bulk discounts start from 10 units; for large rollouts (500+), we offer dedicated project pricing." },
  { q: "What file formats do you accept?", a: "We accept AI, PSD, PDF, EPS, PNG and JPG. For best results, supply vector files at print-ready resolution (300 DPI) with embedded fonts and bleed." },
  { q: "How long does production typically take?", a: "Standard turnaround is 3–5 working days. Complex fabrication (signage, exhibition stands) may take 7–10 days. Express options shorten this to 24–48 hours." },
  { q: "Do you ship internationally?", a: "Yes — worldwide courier shipping is available with full customs handling. Quotation includes destination duties, insurance and tracking." },
];

export default function FAQ() {
  return (
    <PageShell>
      <PageHeader
        overline="FAQ"
        title={<>Answers to the questions<br />we hear most often.</>}
        subtitle="Everything you need to know about working with Printzee — from turnaround times to delivery and customisation."
        breadcrumbs={[{ to: "/", label: "Home" }, { label: "FAQ" }]}
      />

      <section className="bg-white dark:bg-[#0B1120] py-20 md:py-28 transition-colors">
        <div className="pz-container max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Accordion type="single" collapsible className="space-y-3">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`f-${i}`}
                  data-testid={`faq-page-item-${i}`}
                  className="border border-slate-200 dark:border-white/10 rounded-2xl px-6 bg-white dark:bg-white/[0.03] data-[state=open]:border-[#0F172A] dark:data-[state=open]:border-[#F59E0B] data-[state=open]:shadow-md transition-all"
                >
                  <AccordionTrigger className="text-left font-display font-medium text-base sm:text-lg text-[#0F172A] dark:text-white hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 dark:text-white/70 text-[15px] leading-relaxed pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </section>

      <CTASection />
      <SiteFooter />
    </PageShell>
  );
}
